module.exports = __webpack_public_path__ + "static/media/battle_axe.299119a1.png";